import * as React from "react";
import { useNavigate } from "react-router";
export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.ReactElement;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  let navigate = useNavigate();
  if (localStorage.getItem("access_token") != null) {
    return outlet;
  } else {
    localStorage.clear();
    setTimeout(() => {
      navigate(authenticationPath);
    }, 300);
    return null;
  }
}
